import React, {Component} from 'react';
import {connect} from 'react-redux';

class SyllabusLecture extends Component {
    render(){


        return (
            <li>
                {this.props.index + 1}. {this.props.chapter.name}                        
                <div className="progressBarWrapSyllabus">
                    <div className="progressBarSyllabus bg-success" style={{width: String(this.props.progress || 0) + '%'}}></div>
                </div>
            </li>
        )
    }
}

const mapStateToProps = (state) => ({
    ...state.auth,
    ...state.video
});

const mapDispatchToProps = (dispatch) => ({

})

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(SyllabusLecture);


// WEBPACK FOOTER //
// ./src/components/Common/SyllabusLecture.js